(function() {
  angular.module('admin')
  .controller('corporateProfileController', ['$scope', '$log', 'MyDso', '$state', 'secSecurityService',
    function($scope, $log, MyDso, $state, secSecurityService) {
      var vm = this;
      vm.submit = submit;
      vm.reset = reset;
      vm.running = false;
      vm.dso = getDso();

      secSecurityService.hasAnyAuthority('PREVIOUS_ADMINISTRATOR').then((val) => {
        vm.inUserView = val;
      });
      function submit() {
        $scope.errorControl.showErrors();
        if ($scope.corporateProfileForm.$valid) {
          vm.running = true;
          MyDso().save(vm.dso, function() {
            vm.running = false;
            vm.originalDso = angular.copy(vm.dso);
            $scope.dnConfirmationMessage.$show("Your Corporate Profile has been successfully updated.");
          },function(error){
            vm.running = false;
            throw error;
          });
        }
      }
      function reset() {
        vm.dso = angular.copy(vm.originalDso);
        $scope.corporateProfileForm.$setPristine();
      }
      function getDso() {
        return MyDso().get(function(dso) {
          vm.originalDso = angular.copy(dso);
          return dso;
        },function(error){
           $state.go('root');
           throw error;
        });
      }
    }]);
})();
